import { createContext } from 'react';

const ToastContext = createContext();

ToastContext.displayName = 'ToastContext';

export default ToastContext;
